import { NewstaffProfile } from 'src/app/auth/tokens';

/** Default journal author for the signed-in staff member. */
export function defaultJournalAuthorForUser(user: NewstaffProfile | null | undefined): string {
  if (!user) {
    return '';
  }
  if (user.restricted === 1) {
    return (user.first ?? '').trim();
  }
  return user.name ?? '';
}
